<template>
    <div :class="{ hide: activeStep !== 1, show: activeStep === 1 }" style="display: flex;">
        <div class="flex-container" style="width:100%">
            <div style="width:100%"
                v-for="(cabin, cabinIndex) in payload.cabins"
                :key="cabinIndex"
                :class="{ dim: !(cabinIndex === 0) }"
            >
                {{ totalPax }}
                <CabinConfig
                    :cabin="cabin"
                    :index="cabinIndex"
                    :cruise="cruise"
                    :setActiveStep="setActiveStep"
                    :setPeopleAndStep="setPeopleAndStep"
                    :minAdult="minAdult"
                    v-on:changeCompany="changeCompany"
                    v-on:changeBirthdateCompany="changeBirthdateCompany"
                    v-on:resetCabinConfig-click="resetCabinConfig"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CabinConfig from './CabinConfig.vue'

export default {
    name: 'CabinConfigActive',
    components: {
        CabinConfig,
    },
    props: {
        activeStep: Number,
        payload: Object,
        cruise: Object,
        resetCabinConfig: Function,
        changeCompany: Function,
        changeBirthdateCompany: Function,
        totalPax: Number,
        minAdult: Number,
      setActiveStep: Function,
      setPeopleAndStep: Function,
    },
}
</script>
